import Melody1 from '../Melody/Melody (1).webp'
import Melody2 from '../Melody/Melody (2).webp'
import Melody3 from '../Melody/Melody (3).webp'

const Melodyimages =[
Melody1,Melody2,Melody3
]

export default Melodyimages;